export const REASON_ABSENCE = "REASON_ABSENCE";
export const REASON_REQUEST = "REASON_REQUEST";
export const REASON_ADDRESS_ERROR = "REASON_ADDRESS_ERROR";
export const REASON_MOBILE_ERROR = "REASON_MOBILE_ERROR";
export const REASON_NO_SPACE = "REASON_NO_SPACE";
export const REASON_RECEIVER_REFUSAL = "REASON_RECEIVER_REFUSAL";
export const REASON_UNHANDLEABLE_CARGO = "REASON_UNHANDLEABLE_CARGO";
export const REASON_MISDELIVERY_RETURN_REQUEST =
  "REASON_MISDELIVERY_RETURN_REQUEST";
export const MISCLASSIFICATION = "MISCLASSIFICATION";
export const REASON_WRONG_ADDRESS = "REASON_WRONG_ADDRESS";
export const REASON_HEAVY_RAIN = "REASON_HEAVY_RAIN";
export const REASON_HEAVY_SNOW = "REASON_HEAVY_SNOW";
export const REASON_ROAD_PROBLEM = "REASON_ROAD_PROBLEM";
export const REASON_DELIVERY_ADDRESS_PROBLEM = "REASON_DELIVERY_ADDRESS_PROBLEM";
export const REASON_VEHICLE_FAULT = "REASON_VEHICLE_FAULT";
export const REASON_PRODUCT_DAMAGE = "REASON_PRODUCT_DAMAGE";
export const REASON_NOT_TODAY = "REASON_NOT_TODAY";
export const REASON_ETC = "REASON_ETC";
export const REASON_NEXT_DELIVERY = "REASON_NEXT_DELIVERY";
export const REASON_LOST = "REASON_LOST";
export const REASON_BREAKAGE = "REASON_BREAKAGE";
export const REASON_CONTENT_LOST = "REASON_CONTENT_LOST";

export const DELAY_REASONS = [
  {
    text: "다음 회차",
    code: REASON_NEXT_DELIVERY,
    shortText: "다음회차",
  },
  {
    text: "수령인 부재",
    code: REASON_ABSENCE,
    shortText: "수령인부재",
  },
  {
    text: "고객지정일(수령인 요청)",
    code: REASON_REQUEST,
    shortText: "고객지정일",
  },
  {
    text: "주소지 오류",
    code: REASON_ADDRESS_ERROR,
    shortText: "주소지오류",
  },
  {
    text: "연락처 오류",
    code: REASON_MOBILE_ERROR,
    shortText: "연락처오류",
  },
  {
    text: "출입불가 및 보관장소없음",
    code: REASON_NO_SPACE,
    shortText: "출입불가",
  },
  {
    text: "수취거부",
    code: REASON_RECEIVER_REFUSAL,
    shortText: "수취거부",
  },
  {
    text: "취급불가 화물",
    code: REASON_UNHANDLEABLE_CARGO,
    shortText: "취급불가",
  },
  {
    text: "오배송반송요청",
    code: REASON_MISDELIVERY_RETURN_REQUEST,
    shortText: "오배송반송",
  },
  {
    text: "오분류",
    code: MISCLASSIFICATION,
    shortText: "오분류",
  },
  {
    text: "배송불가지역",
    code: REASON_WRONG_ADDRESS,
    shortText: "배송불가지역",
  },
  {
    text: "기상악화(폭우)",
    code: REASON_HEAVY_RAIN,
    shortText: "폭우",
  },
  {
    text: "기상악화(폭설)",
    code: REASON_HEAVY_SNOW,
    shortText: "폭설",
  },
  {
    text: "도로문제(도로통제등)",
    code: REASON_ROAD_PROBLEM,
    shortText: "도로문제",
  },
  {
    text: "배송지문제(정전등)",
    code: REASON_DELIVERY_ADDRESS_PROBLEM,
    shortText: "배송지문제",
  },
  {
    text: "차량사고(차량고장)",
    code: REASON_VEHICLE_FAULT,
    shortText: "차량문제",
  },
  {
    text: "상품 파손",
    code: REASON_PRODUCT_DAMAGE,
  },
  {
    text: "순차배송예정(당일배송불가)",
    code: REASON_NOT_TODAY,
    shortText: "순차처리",
  },
  {
    text: "기타",
    code: REASON_ETC,
    shortText: "기타",
  },
];

export const RETURN_APPROVE_REASON_CODES = [
  REASON_ABSENCE,
  REASON_ADDRESS_ERROR,
  REASON_MOBILE_ERROR,
  REASON_NO_SPACE,
  REASON_RECEIVER_REFUSAL,
  REASON_UNHANDLEABLE_CARGO,
  REASON_MISDELIVERY_RETURN_REQUEST,
  REASON_WRONG_ADDRESS,
];

export const normalizeDelayReasonCode = (code = "") => {
  if (!code) {
    return "";
  }

  return code.includes("DELIVERY_POSTPONED_")
    ? code.split("DELIVERY_POSTPONED_")[1]
    : code;
};

export const LOST_REASONS = [
  {
    text: "배송위치 확인 불가(오배송 분실)",
    code: REASON_ADDRESS_ERROR,
  },
  {
    text: "배송 중 유실",
    code: REASON_LOST,
  },
  {
    text: "배송 중 파손",
    code: REASON_BREAKAGE,
  },
  {
    text: "내품 분실",
    code: REASON_CONTENT_LOST,
  },
  {
    text: "기타",
    code: REASON_ETC,
  },
];

export const normalizeLostReasonCode = (code = "") => {
  if (!code) {
    return "";
  }

  return code.includes("DELIVERY_LOST_")
    ? code.split("DELIVERY_LOST_")[1]
    : code;
};
